module.exports = __webpack_public_path__ + "img/type_qt.9f0aa51c.png";